import Vue from 'vue'
import HeaderBlock from './HeaderBlock.vue'
import Comments from './Comments.vue'

const app = new Vue({
	el: '#app',
	components: {
		'header-block': HeaderBlock,
		'comments': Comments,
	},
	data: {
		count: 0,

		env: null,

		user: {
			isAuth: false,
			id: 0,
			name: '',
			email: '',
		},

		socket: {
			address: location.host,
			port: 8880,
			server: null
		}
	},

	mounted: function () {
		this.env = this.$el.dataset.env;

		if (this.$el.dataset.user != 'null') {
			var user = JSON.parse(this.$el.dataset.user);
			this.user.isAuth = true;
			this.user.id = user.id;
			this.user.name = user.name;
			this.user.email = user.email;
		}

		this.$on('login', this.login);

		//this.connection();
	},

	methods: {
		login: function (data) {
			var email = data.email,
				password = data.password;

			var request = $.ajax('/api/v1/login', {
				'method': 'post',
				'data': {
					'login-form': {
						login: email,
						password: password
					}
				},
				'dataType': 'json'
			});

			request.then(function (data) {
				if (data.status === 'login') {
					this.user.isAuth = true;
					this.user.id = data.user.id;
					this.user.name = data.user.name;
					this.user.email = data.user.email;
				} else if (data.status === 'error') {
					if (data.message === 'notValid') {
						alert('Не верный логин или пароль.');
					} else if (data.message === 'notConfirmed') {
						alert('Ваш емайл не подтверждён. Проверьте свою почту.');
					}
				}
			}.bind(this));
		},

		connection: function () {
			var protocol = 'ws';
			if (this.dataEnv === 'prod') {
				protocol = 'wss';
			}
			
			this.socket.server = new WebSocket(protocol+'://'+this.socket.address+':'+this.socket.port);

			this.socket.server.onclose = function () {
				setTimeout(this.connection, 1000);
			};

			this.socket.server.onmessage = function (evt) {
				var data = JSON.parse(evt.data);
				this.count = data.count;
			}.bind(this);
		}
	}
});